import React from "react";
import { NavLink } from "react-router-dom";

function Section_7() {
  return (
    <section className="csrd-landing-page-section-7-container">
      <div className="section-7-banner">
        <div
          className="section-7-banner-content"
          data-aos="zoom-in"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-easing="ease"
          data-aos-once="true">
          <div className="section-7-banner-header">Book a Free Demo Today</div>
          <button className="section-7-banner-button">
            <NavLink to="/demo" className="home-banner-get-started-btn">
              Book a Demo Now
            </NavLink>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Section_7;
